const form = document.querySelector('form');

if (form) {
	function validateField(field) {
		const errorElement =
			field.type === 'radio'
				? field.closest('fieldset')?.querySelector('.error-message')
				: field.parentElement?.querySelector('.error-message');

		if (!errorElement) {
			return field.validity.valid;
		}

		if (!field.validity.valid) {
			errorElement.textContent =
				field.dataset.error || 'Mező kitöltése kötelező';

			return false;
		}

		errorElement.textContent = '';
		return true;
	}

	const fields = form.querySelectorAll('input, textarea');

	fields.forEach((field) => {
		field.addEventListener('blur', () => {
			validateField(field);
		});
	});

	form.addEventListener('submit', (event) => {
		event.preventDefault();

		let isValid = true;

		fields.forEach((field) => {
			if (!validateField(field)) {
				isValid = false;
			}
		});

		if (isValid) {
			form.reset();
		} else {
			form.querySelector(':invalid')?.focus();
		}
	});
}